import React, { useState } from "react";
import './Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Hardcoded credentials as requested
        // You must set ADMIN_TOKEN = "admin-secret-token" in your Cloudflare Worker variables
        if (username === 'admin' && password === 'esponjoboda2026') {
            localStorage.setItem('adminToken', 'admin-secret-token');
            window.location.href = '/admin';
        } else {
            setError('Credenciales incorrectas');
        }
    };

    return (
        <div className="login-container">
            <h2>¡Bienvenidos Novios!</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="username">Usuario:</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Contraseña:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit" className="login-button">Iniciar Sesión</button>
            </form>
        </div>
    );
}
export default Login;